import { LoadingScreen as BaseLoadingScreen } from '@growtherapy/sprout-ui';

export function LoadingScreen() {
  return <BaseLoadingScreen className='bg-neutral-100' />;
}
